(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2681],{

/***/ 43029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_auth_fe__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50671);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86872);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22470);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(2267);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55046);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97501);
/* harmony import */ var helpers_useBuyerOffers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13839);
/* harmony import */ var _helpers_observability__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9574);
/* harmony import */ var _helpers_useLeads__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65609);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61661);











var AccountMenu = function(props) {
    var trackEvent = (0,_helpers_observability__WEBPACK_IMPORTED_MODULE_2__/* .useObservability */ .C3)().trackEvent;
    var helpCenterUrl = "https://help.opendoor.com";
    var ref = (0,_opendoor_auth_fe__WEBPACK_IMPORTED_MODULE_5__/* .useAuth */ .aC)(), human = ref.user, logout = ref.logout;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), hasResaleDashboard = ref1[0], setHasResaleDashboard = ref1[1];
    var leads = (0,_helpers_useLeads__WEBPACK_IMPORTED_MODULE_3__/* .useLeads */ .v)();
    var hasActiveOffers = (0,helpers_useBuyerOffers__WEBPACK_IMPORTED_MODULE_1__/* .useHasActiveBuyerOffers */ .w)(props.isExpanded).hasActiveOffers;
    var hasLeads = leads && leads.length > 0;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!human) {
            return;
        }
        (0,_api__WEBPACK_IMPORTED_MODULE_4__/* .getSessionExtras */ .DF)().then(function(extras) {
            setHasResaleDashboard(extras.has_resale_closing_dashboard);
        });
    }, [
        human === null || human === void 0 ? void 0 : human.humanToken,
        human === null || human === void 0 ? void 0 : human.customerUuid
    ]);
    var handleSignOutClick = function() {
        // TODO: remove categoryOverride
        // observability is initialized with 'cosmos' as the category for all events
        trackEvent("cta-click", "account-signout", undefined, {
            categoryOverride: "homepage"
        });
        logout();
    };
    if (!props.isLoggedIn) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(PrimaryNavSubmenu, {
            isExpanded: props.isExpanded,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(PrimaryNavItem, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MenuItem, {
                    href: helpCenterUrl,
                    children: "Help center"
                })
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(PrimaryNavSubmenu, {
        isExpanded: props.isExpanded,
        children: [
            hasLeads && leads.slice(0, 3).map(function(lead) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(PrimaryNavItem, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(MenuItem, {
                        href: lead.url,
                        children: [
                            lead.address.street,
                            lead.readable_offer_state && " (".concat(lead.readable_offer_state, ")")
                        ]
                    })
                }, lead.id);
            }),
            leads && leads.length > 3 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(PrimaryNavItem, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MenuItem, {
                    href: "/properties",
                    children: "More"
                })
            }),
            hasLeads && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(Divider, {}),
            hasResaleDashboard && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(PrimaryNavItem, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MenuItem, {
                    href: "/closing-dashboard",
                    children: "Closing dash"
                })
            }),
            hasResaleDashboard && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(Divider, {}),
            hasActiveOffers && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(PrimaryNavItem, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MenuItem, {
                    icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        size: 20,
                        stroke: 1.5,
                        color: (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__.getToken)("$contentPrimary", "color")
                    }),
                    onClick: function() {
                        return trackEvent("cta-click", "dashboard-link", undefined, {
                            categoryOverride: "homepage"
                        });
                    },
                    href: "/dashboard",
                    children: "Dashboard"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(PrimaryNavItem, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MenuItem, {
                    // TODO: remove categoryOverride
                    // observability is initialized with 'cosmos' as the category for all events
                    onClick: function() {
                        return trackEvent("cta-click", "account-link", undefined, {
                            categoryOverride: "homepage"
                        });
                    },
                    href: "/account",
                    children: "Account"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(Divider, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(PrimaryNavItem, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MenuItem, {
                    href: helpCenterUrl,
                    children: "Help center"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(PrimaryNavItem, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MenuButton, {
                    onPress: handleSignOutClick,
                    label: "Sign out",
                    icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        size: 20,
                        stroke: 1.5,
                        color: (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__.getToken)("$contentPrimary", "color")
                    }),
                    analyticsName: "cosmos-account-menu-sign-out"
                })
            })
        ]
    });
};
var PrimaryNavSubmenu = function(param) {
    var isExpanded = param.isExpanded, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, !isExpanded ? {
        inert: ""
    } : {}), {
        position: "absolute",
        // 100% clears the avatar; +12px covers the remaining space between the
        // avatar bottom and the header bar bottom (avatar is vertically centered)
        top: "calc(100% + 12px)",
        right: 0,
        backgroundColor: "$backgroundPrimary",
        borderRadius: "$3x",
        borderWidth: 1,
        borderColor: "$borderPrimary",
        minWidth: 198,
        padding: "$2x",
        gap: "$2x",
        overflow: "hidden",
        zIndex: 1000,
        opacity: isExpanded ? 1 : 0,
        "aria-hidden": !isExpanded,
        tag: "ul",
        style: {
            visibility: isExpanded ? "visible" : "hidden",
            transition: "opacity 0.2s ease, visibility 0.2s ease",
            listStyle: "none",
            margin: 0
        },
        children: children
    }));
};
var PrimaryNavItem = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .x, {
        tag: "li",
        children: children
    });
};
var Divider = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .x, {
        role: "separator",
        height: 1,
        backgroundColor: "$borderSecondary"
    });
};
var MenuItem = function(param) {
    var href = param.href, children = param.children, icon = param.icon, onClick = param.onClick;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Link */ .r, {
        href: href,
        onPress: onClick,
        analyticsName: "",
        color: "$contentPrimary",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .x, {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "$4x",
            paddingVertical: "$4x",
            paddingRight: "$6x",
            paddingLeft: icon ? "$4x" : 30,
            borderRadius: "$2x",
            hoverStyle: {
                backgroundColor: "$backgroundStateHoverPrimary"
            },
            cursor: "pointer",
            children: [
                icon && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .x, {
                    width: 20,
                    height: 20,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    children: icon
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                    tag: "span",
                    typography: "$bodyMedium",
                    color: "$contentPrimary",
                    whiteSpace: "nowrap",
                    children: children
                })
            ]
        })
    });
};
var MenuButton = function(param) {
    var onPress = param.onPress, label = param.label, icon = param.icon, analyticsName = param.analyticsName;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .PressableBox */ .K, {
        onPress: onPress,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "$4x",
        paddingVertical: "$4x",
        paddingRight: "$6x",
        paddingLeft: icon ? "$4x" : 30,
        borderRadius: "$2x",
        hoverStyle: {
            backgroundColor: "$backgroundStateHoverPrimary"
        },
        cursor: "pointer",
        "aria-label": label,
        analyticsName: analyticsName,
        children: [
            icon && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .x, {
                width: 20,
                height: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                children: icon
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                tag: "span",
                typography: "$bodyMedium",
                color: "$contentPrimary",
                whiteSpace: "nowrap",
                children: label
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccountMenu);


/***/ }),

/***/ 8222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ OpendoorLogoBadge; },
/* harmony export */   "o": function() { return /* binding */ OpendoorLogo; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35944);

var OpendoorLogo = function(param) {
    var _width = param.width, width = _width === void 0 ? "256px" : _width;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "256",
        height: "56",
        viewBox: "0 0 256 56",
        fill: "none",
        style: {
            height: "auto",
            maxWidth: "100%",
            width: width
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
            d: "M154.378 38.5472L154.378 38.5473C153.466 38.9528 152.132 39.5455 150.289 39.5455C146.07 39.5455 143.85 36.6648 143.85 27.7977C143.85 18.4782 146.626 15.4851 150.622 15.4851C152.677 15.4851 154.009 16.671 154.952 17.857V38.3027C154.783 38.3671 154.592 38.452 154.378 38.5472ZM163.778 7.69108C163.778 4.7717 163.876 2.08934 163.928 0.988439C163.943 0.66633 163.674 0.407602 163.359 0.436253L155.364 1.36004C155.131 1.38131 154.952 1.57969 154.952 1.81802V9.72444C154.952 11.7574 155.063 13.8472 155.063 13.8472C153.898 13.5081 152.343 13.226 150.845 13.226C142.185 13.226 134.746 17.9139 134.746 29.6617C134.746 39.9406 140.13 44.0073 145.626 44.0073C149.512 44.0073 152.621 42.4258 155.008 40.3365H155.23L155.117 43.4538C155.104 43.7859 155.389 44.0485 155.712 44.0021L163.328 43.1369C163.586 43.1004 163.778 42.8756 163.778 42.6103V7.69108ZM18.6517 5.8832C24.7573 5.8832 26.9781 11.3616 26.9781 24.5776C26.9781 37.8501 24.3691 41.6346 18.8736 41.6346C12.6562 41.6346 10.5468 36.2122 10.5468 23.0531C10.5468 9.72376 13.2668 5.8832 18.6517 5.8832ZM18.985 3.51123C10.0471 3.51123 0 9.38472 0 24.239C0 37.7941 8.99286 44.0066 18.5399 44.0066C27.4778 44.0066 37.5249 38.302 37.5249 23.3352C37.5249 9.32872 28.5325 3.51123 18.985 3.51123ZM50.4951 39.7148C51.4948 40.9007 52.9932 41.7481 54.8808 41.7481C59.2661 41.7481 61.5978 39.3761 61.5978 29.04C61.5978 20.9634 59.2106 18.1396 54.9917 18.1396C53.0406 18.1396 51.7322 18.6632 50.8408 19.0199L50.8406 19.02L50.8402 19.0202C50.7175 19.0693 50.6026 19.1153 50.4951 19.1562V39.7148ZM50.4951 17.1233C52.8273 15.0899 55.9351 13.2263 59.8212 13.2263C65.0948 13.2263 70.7012 16.7843 70.7012 27.12C70.7012 38.8678 63.9291 44.0072 54.6589 44.0072C53.4933 44.0072 51.6612 43.7815 50.4401 43.4429C50.4401 43.4429 50.4951 44.9115 50.4951 46.888V52.0413V54.5539C50.4951 54.7879 50.3227 54.9845 50.0945 55.0106L42.1713 55.9213C41.9033 55.9522 41.6691 55.7386 41.6691 55.4646V52.0413V14.5686C41.6691 14.3346 41.8414 14.1379 42.0701 14.1115L49.7732 13.2255C50.0736 13.1907 50.3347 13.436 50.3249 13.7438L50.2178 17.1233H50.4951ZM82.7352 25.1992L92.2272 24.6908C92.2272 17.8571 91.3398 15.3718 88.0088 15.3718C85.1774 15.3718 82.957 18.0828 82.7352 25.1992ZM73.9646 28.5314C73.9646 18.704 81.1249 13.2256 88.4525 13.2256C96.0237 13.2256 100.775 17.0314 101.046 26.9886C101.051 27.1822 100.896 27.3454 100.705 27.3454H83.0837C82.8926 27.3454 82.7382 27.5086 82.7428 27.7027C82.9912 36.674 86.4173 39.1497 92.0608 39.1497C94.8154 39.1497 97.0362 38.4985 98.8947 37.6598C99.0317 37.5977 99.1904 37.6342 99.2881 37.7505L100.026 38.634C100.138 38.7672 100.136 38.9643 100.019 39.0911C97.9936 41.2638 93.8712 44.0069 88.4525 44.0069C78.7936 44.0069 73.9646 38.133 73.9646 28.5314ZM113.208 17.236C116.149 15.0902 119.813 13.2262 123.865 13.2262C128.584 13.2262 131.138 15.7114 131.138 20.7948V42.8819C131.138 43.1293 130.94 43.3294 130.697 43.3294H122.696C122.453 43.3294 122.256 43.1293 122.256 42.8819V22.9971C122.256 19.552 121.034 18.4789 118.426 18.4789C116.482 18.4789 114.484 18.9303 113.263 19.2129V42.8819C113.263 43.1293 113.065 43.3294 112.823 43.3294H104.876C104.634 43.3294 104.437 43.1293 104.437 42.8819V14.568C104.437 14.334 104.609 14.1378 104.838 14.1117L112.606 13.2157C112.872 13.1854 113.103 13.402 113.094 13.675L112.985 17.236H113.208ZM182.333 15.4283C186.108 15.4283 188.273 17.5745 188.273 28.9833C188.273 39.8273 185.998 41.8038 182.666 41.8038C178.614 41.8038 176.782 39.3194 176.782 27.7409C176.782 18.0264 178.836 15.4283 182.333 15.4283ZM182.5 13.2256C175.006 13.2256 167.457 17.8567 167.457 28.7011C167.457 39.0364 174.451 44.0074 182.5 44.0074C190.161 44.0074 197.599 39.2626 197.599 28.4185C197.599 18.1393 190.549 13.2256 182.5 13.2256ZM221.382 28.9833C221.382 17.5745 219.218 15.4283 215.443 15.4283C211.945 15.4283 209.892 18.0264 209.892 27.7409C209.892 39.3194 211.724 41.8038 215.776 41.8038C219.107 41.8038 221.382 39.8273 221.382 28.9833ZM200.565 28.7011C200.565 17.8567 208.115 13.2256 215.609 13.2256C223.658 13.2256 230.708 18.1393 230.708 28.4185C230.708 39.2626 223.27 44.0074 215.609 44.0074C207.56 44.0074 200.565 39.0364 200.565 28.7011ZM243.234 17.5745C244.954 15.7109 248.118 13.2256 251.338 13.2256C254.002 13.2256 255.883 14.6937 255.883 17.4616C255.883 20.1726 253.947 21.9186 251.782 21.9186C249.397 21.9186 248.562 20.9067 247.508 19.1559C247.175 18.5347 246.841 18.4214 246.341 18.4214C245.343 18.4214 244.066 19.1559 243.289 19.8905V42.7975C243.289 43.091 243.054 43.3288 242.766 43.3288H234.985C234.696 43.3288 234.463 43.091 234.463 42.7975V14.5683C234.463 14.3339 234.635 14.1376 234.864 14.1116L242.539 13.2351C242.854 13.1991 243.129 13.4561 243.119 13.7791L243.011 17.5745H243.234Z",
            fill: "currentColor"
        })
    });
};
var OpendoorLogoBadge = function(param) {
    var _width = param.width, width = _width === void 0 ? "14px" : _width;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "20",
        viewBox: "0 0 14 20",
        fill: "none",
        style: {
            height: "auto",
            maxWidth: "100%",
            width: width
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.0652 7.72525C10.0652 2.87886 9.23666 0.869951 6.95864 0.869951C4.94968 0.869951 3.93488 2.27822 3.93488 7.16613C3.93488 11.9918 4.7219 13.9801 7.04144 13.9801C9.09177 13.9801 10.0652 12.5924 10.0652 7.72525ZM0 7.60107C0 2.15396 3.74854 0 7.08288 0C10.645 0 14 2.13332 14 7.26967C14 12.7581 10.2515 14.85 6.91711 14.85C3.35507 14.85 0 12.5718 0 7.60107ZM13.2689 19.2321C12.929 18.7812 11.6198 17.0442 11.6198 17.0442C11.4969 16.8812 11.2864 16.7829 11.0605 16.7829H2.93952C2.71362 16.7829 2.50312 16.8812 2.38028 17.0442L0.731324 19.2318C0.679012 19.3011 0.651254 19.3819 0.651254 19.4645V19.7984C0.651254 19.9098 0.741489 20 0.852838 20H13.1472C13.2585 20 13.3488 19.9098 13.3488 19.7984V19.4645C13.3488 19.3819 13.3213 19.3014 13.2689 19.2321Z",
            fill: "currentColor"
        })
    });
};


/***/ }),

/***/ 65253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ AccountSection; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/PressableBox.js
var PressableBox = __webpack_require__(2267);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./src/components/account/AccountMenu.tsx
var AccountMenu = __webpack_require__(43029);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Link/Link.js
var Link = __webpack_require__(22470);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/LoginSection.tsx



var LoginSection = function(param) {
    var showLogin = param.showLogin, onPress = param.onPress, foregroundColor = param.foregroundColor;
    if (!showLogin) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
        href: "#",
        onPress: onPress,
        fontWeight: "$medium",
        analyticsName: "cosmos-sign-in",
        "aria-label": "Sign in to your account",
        color: foregroundColor || "$contentPrimary",
        children: "Sign in"
    });
};

// EXTERNAL MODULE: ./src/helpers/observability.ts
var observability = __webpack_require__(9574);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/GlobalNavSVG.tsx
/*
  Saves us from making a network request to https://images.opendoor.com/source/s3/imgdrop-production/2023-06-1687822944103-28395.svg?preset=square-2048

*/ 

var GlobalNavSVG = function(param) {
    var isOpen = param.isOpen;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        className: isOpen ? "is-open" : undefined,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(".menu-bar-top,.menu-bar-bottom{transform-origin:center;transition:transform 0.3s cubic-bezier(0.55,0,0.15,1);}.menu-bar-top{transform:translateY(-4px);}.menu-bar-bottom{transform:translateY(4px);}&.is-open .menu-bar-top{transform:rotate(45deg);}&.is-open .menu-bar-bottom{transform:rotate(-45deg);}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                className: "menu-bar-top",
                d: "M4 12H20",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                className: "menu-bar-bottom",
                d: "M4 12H20",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/AccountSection.tsx







var AccountSection = function(param) {
    var isLoggedIn = param.isLoggedIn, showLogin = param.showLogin, initials = param.initials, redirectToLogin = param.redirectToLogin, trackAccountClick = param.trackAccountClick, trackMenuClick = param.trackMenuClick, onMobileMenuToggle = param.onMobileMenuToggle, isMobileMenuVisible = param.isMobileMenuVisible, hamburgerRef = param.hamburgerRef, foregroundColor = param.foregroundColor;
    var fgColor = foregroundColor || (0,cjs.getToken)("$contentPrimary", "color");
    var trackJourneyEvent = (0,observability/* useObservability */.C3)().trackJourneyEvent;
    var largerThanSM = (0,cjs.useMedia)().largerThanSM;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setExpanded = ref[1];
    var containerRef = (0,react.useRef)(null);
    var toggleDropdown = (0,react.useCallback)(function() {
        return setExpanded(function(prev) {
            return !prev;
        });
    }, []);
    var closeDropdown = (0,react.useCallback)(function() {
        return setExpanded(false);
    }, []);
    (0,react.useEffect)(function() {
        if (!isExpanded) return;
        var handleClickOutside = function(event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                closeDropdown();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isExpanded,
        closeDropdown
    ]);
    var handleEscape = (0,react.useCallback)(function(event) {
        if (event.key === "Escape") {
            closeDropdown();
        }
    }, [
        closeDropdown
    ]);
    (0,react.useEffect)(function() {
        if (!isExpanded) return;
        document.addEventListener("keydown", handleEscape);
        return function() {
            document.removeEventListener("keydown", handleEscape);
        };
    }, [
        isExpanded,
        handleEscape
    ]);
    var handleAvatarPress = (0,react.useCallback)(function() {
        trackAccountClick();
        trackMenuClick();
        trackJourneyEvent("platform", "buttonClickEvent", {
            targetName: "user-account-menu-click"
        });
        toggleDropdown();
    }, [
        trackAccountClick,
        trackMenuClick,
        trackJourneyEvent,
        toggleDropdown
    ]);
    var handleLoginPress = (0,react.useCallback)(function() {
        trackAccountClick();
        trackJourneyEvent("platform", "buttonClickEvent", {
            targetName: "account-section-click"
        });
        redirectToLogin();
    }, [
        trackAccountClick,
        trackJourneyEvent,
        redirectToLogin
    ]);
    var handleDotsPress = (0,react.useCallback)(function(e) {
        var ref;
        e === null || e === void 0 ? void 0 : (ref = e.stopPropagation) === null || ref === void 0 ? void 0 : ref.call(e);
        trackMenuClick();
        toggleDropdown();
    }, [
        trackMenuClick,
        toggleDropdown
    ]);
    var handleMobileMenuPress = (0,react.useCallback)(function() {
        trackMenuClick();
        onMobileMenuToggle();
    }, [
        trackMenuClick,
        onMobileMenuToggle
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        ref: containerRef,
        position: "relative",
        display: "flex",
        alignItems: "center",
        gap: "$6x",
        children: [
            isLoggedIn ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                        onPress: handleAvatarPress,
                        analyticsName: "account-section-click",
                        "aria-label": "User account menu",
                        "aria-haspopup": "true",
                        "aria-expanded": isExpanded,
                        $smallerThanMD: {
                            display: "none"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 32,
                            height: 32,
                            borderRadius: "$60x",
                            backgroundColor: "$backgroundInversePrimary",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$labelSmall",
                                fontWeight: "$medium",
                                color: "$contentInversePrimary",
                                children: initials
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        $largerThanSM: {
                            display: "none"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                            ref: hamburgerRef,
                            onPress: handleMobileMenuPress,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            style: {
                                color: fgColor
                            },
                            focusStyle: {
                                outlineStyle: "none"
                            },
                            focusVisibleStyle: {
                                outlineStyle: "none"
                            },
                            "aria-label": "Navigation menu",
                            "aria-haspopup": "true",
                            "aria-expanded": isMobileMenuVisible,
                            analyticsName: "cosmos-landing-page-header-menu-button",
                            "data-testid": "icon-hamburger",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalNavSVG, {
                                isOpen: isMobileMenuVisible
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "$6x",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoginSection, {
                        showLogin: showLogin,
                        onPress: handleLoginPress,
                        foregroundColor: foregroundColor
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        $smallerThanMD: {
                            display: "none"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                            onPress: handleDotsPress,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            "aria-label": "More options",
                            "aria-haspopup": "true",
                            "aria-expanded": isExpanded,
                            analyticsName: "cosmos-landing-page-header-menu-button",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 20 20",
                                fill: fgColor,
                                "data-testid": "icon-dots",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                                        cx: "4",
                                        cy: "10",
                                        r: "1.75"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                                        cx: "10",
                                        cy: "10",
                                        r: "1.75"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                                        cx: "16",
                                        cy: "10",
                                        r: "1.75"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        $largerThanSM: {
                            display: "none"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                            ref: hamburgerRef,
                            onPress: handleMobileMenuPress,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            style: {
                                color: fgColor
                            },
                            focusStyle: {
                                outlineStyle: "none"
                            },
                            focusVisibleStyle: {
                                outlineStyle: "none"
                            },
                            "aria-label": "Navigation menu",
                            "aria-haspopup": "true",
                            "aria-expanded": isMobileMenuVisible,
                            analyticsName: "cosmos-landing-page-header-menu-button",
                            "data-testid": "icon-hamburger",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalNavSVG, {
                                isOpen: isMobileMenuVisible
                            })
                        })
                    })
                ]
            }),
            largerThanSM && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccountMenu/* default */.Z, {
                isExpanded: isExpanded,
                isLoggedIn: isLoggedIn
            })
        ]
    });
};


/***/ }),

/***/ 32681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ header_Header; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe2.esm.js
var auth_fe2_esm = __webpack_require__(50671);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Row.js
var Row = __webpack_require__(6967);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/utils/getInitials.ts
var getInitials = __webpack_require__(566);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/utils/usePrevious.tsx
var usePrevious = __webpack_require__(60132);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/helpers/observability.ts
var observability = __webpack_require__(9574);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/menu/MenuPanel.tsx + 10 modules
var MenuPanel = __webpack_require__(32654);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/AccountSection.tsx + 2 modules
var AccountSection = __webpack_require__(65253);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/LogoSection.tsx
var LogoSection = __webpack_require__(25530);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Link/Link.js
var Link = __webpack_require__(22470);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/PressableBox.js
var PressableBox = __webpack_require__(2267);
;// CONCATENATED MODULE: ./src/components/shared/EiChevronDownIcon.tsx


var EiChevronDownIcon = function() {
    var ChevronDownSVG = function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
            className: "icon",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "1394.6 97.8 430.2 243.7",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "currentColor",
                d: "M1824.9 129.7c0 8.4-2.8 15.4-8.4 21L1634.2 333c-11.2 11.2-30.9 11.2-42.1 0l-187.9-182.3c-12.6-11.2-12.6-30.9 0-43.5 11.2-12.6 30.9-12.6 43.5 0l164 162.8L1773 108.7c11.2-11.2 30.9-11.2 43.5 0 5.5 5.6 8.4 14 8.4 21z"
            })
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChevronDownSVG, {});
};

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 142 modules
var motion = __webpack_require__(94796);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/MegaNavFlyout.tsx





var flyoutVariants = {
    hidden: {
        opacity: 0,
        y: -10,
        transition: {
            duration: 0.2,
            ease: "easeOut"
        }
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.2,
            ease: "easeOut"
        }
    }
};
var MegaNavFlyout = function(param) {
    var item = param.item, isVisible = param.isVisible, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave, topOffset = param.topOffset;
    var ref;
    var ref1 = (0,react.useState)(false), isAnimationComplete = ref1[0], setIsAnimationComplete = ref1[1];
    // Reset animation complete state when visibility changes
    (0,react.useEffect)(function() {
        if (!isVisible) {
            setIsAnimationComplete(false);
        }
    }, [
        isVisible
    ]);
    var handleAnimationComplete = function(definition) {
        if (definition === "visible") {
            setIsAnimationComplete(true);
        }
    };
    // Only enable mouse events after the open animation completes
    var enableMouseEvents = isVisible && isAnimationComplete;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.div */.E.div, {
        initial: "hidden",
        animate: isVisible ? "visible" : "hidden",
        variants: flyoutVariants,
        onAnimationComplete: handleAnimationComplete,
        onMouseEnter: enableMouseEvents ? onMouseEnter : undefined,
        onMouseLeave: enableMouseEvents ? onMouseLeave : undefined,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:fixed;top:", topOffset, "px;left:0;width:100vw;background:white;box-shadow:0 4px 6px -1px rgba(0,0,0,0.1),0 2px 4px -1px rgba(0,0,0,0.06);z-index:1000;padding:32px 0;/* Always render in HTML for SEO,but control visibility with CSS */\n        opacity:", isVisible ? 1 : 0, ";visibility:", isVisible ? "visible" : "hidden", ";pointer-events:", isVisible ? "auto" : "none", ";"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            width: "100%",
            paddingHorizontal: "$11x",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                display: "flex",
                flexDirection: "row",
                gap: 180,
                justifyContent: "center",
                children: (ref = item.sections) === null || ref === void 0 ? void 0 : ref.map(function(section, sectionIndex) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyMedium",
                                fontWeight: "$medium",
                                marginBottom: "$4x",
                                children: section.title
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                display: "flex",
                                flexDirection: "column",
                                gap: "$3x",
                                children: section.links.map(function(link, linkIndex) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                        href: link.href,
                                        size: "medium",
                                        variant: "secondary",
                                        textDecorationLine: "none",
                                        "aria-label": "Navigate to ".concat(link.name),
                                        analyticsName: "cosmos-mega-nav-".concat(item.name.toLowerCase(), "-").concat(link.name.toLowerCase().replace(/\s+/g, "-")),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                            tag: "span",
                                            typography: "$bodyMedium",
                                            children: link.name
                                        })
                                    }, linkIndex);
                                })
                            })
                        ]
                    }, sectionIndex);
                })
            })
        })
    });
};
/* harmony default export */ var header_MegaNavFlyout = (MegaNavFlyout);

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/MegaNav.tsx








var MegaNav = function(param) {
    var slug = param.slug, megaNavData = param.megaNavData;
    var ref = (0,react.useState)(null), openNavItem = ref[0], setOpenNavItem = ref[1];
    var ref1 = (0,react.useState)(72), flyoutTopOffset = ref1[0], setFlyoutTopOffset = ref1[1];
    var navRef = (0,react.useRef)(null);
    var closeTimerRef = (0,react.useRef)(null);
    var handleMouseEnter = function(itemName) {
        if (closeTimerRef.current) {
            clearTimeout(closeTimerRef.current);
            closeTimerRef.current = null;
        }
        // Calculate the flyout top position based on where the nav actually is in the viewport
        // This accounts for any banners or other elements above the header
        if (navRef.current) {
            var rect = navRef.current.getBoundingClientRect();
            setFlyoutTopOffset(rect.bottom);
        }
        setOpenNavItem(itemName);
    };
    var handleMouseLeave = function() {
        if (closeTimerRef.current) {
            clearTimeout(closeTimerRef.current);
        }
        closeTimerRef.current = setTimeout(function() {
            setOpenNavItem(null);
            closeTimerRef.current = null;
        }, 400);
    };
    (0,react.useEffect)(function() {
        var handleClickOutside = function(event) {
            if (navRef.current && !navRef.current.contains(event.target)) {
                setOpenNavItem(null);
            }
        };
        if (openNavItem) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        openNavItem
    ]);
    (0,react.useEffect)(function() {
        return function() {
            if (closeTimerRef.current) {
                clearTimeout(closeTimerRef.current);
            }
        };
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        display: "block",
        ref: navRef,
        position: "relative",
        "$platform-web": {
            gridColumn: "1 / -1",
            gridRow: "1 / 2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
            m: 0,
            tag: "ul",
            $smallerThanMD: {
                display: "none"
            },
            justifyContent: "center",
            analyticsName: "cosmos-mega-nav-menu-list",
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("list-style:none;"),
            children: megaNavData === null || megaNavData === void 0 ? void 0 : megaNavData.map(function(navItem) {
                var isOpen = openNavItem === navItem.name;
                var hasSections = navItem.sections && navItem.sections.length > 0;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    tag: "li",
                    display: "block",
                    position: "relative"
                }, hasSections && {
                    onMouseEnter: function() {
                        return handleMouseEnter(navItem.name);
                    },
                    onMouseLeave: handleMouseLeave
                }), {
                    children: hasSections ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MegaNavLink, {
                                active: slug === navItem.href,
                                href: navItem.href,
                                name: navItem.name,
                                isOpen: isOpen,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "span",
                                    typography: "$labelMedium",
                                    children: navItem.name
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(header_MegaNavFlyout, {
                                item: navItem,
                                isVisible: isOpen,
                                onMouseEnter: function() {
                                    return handleMouseEnter(navItem.name);
                                },
                                onMouseLeave: handleMouseLeave,
                                topOffset: flyoutTopOffset
                            })
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                        analyticsName: "cosmos-landing-page-v2-nav-link-".concat(navItem.name),
                        "aria-label": "View link",
                        href: navItem.href,
                        "aria-current": slug === navItem.href,
                        color: "$contentPrimary",
                        typography: "$labelMedium",
                        alignItems: "center",
                        py: "$2",
                        px: "$4",
                        display: "inline-flex",
                        height: "100%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "span",
                            typography: "$labelMedium",
                            color: "$contentPrimary",
                            children: navItem.name
                        })
                    })
                }), navItem.name);
            })
        })
    });
};
var MegaNavLink = function(param) {
    var children = param.children, name = param.name, active = param.active, isOpen = param.isOpen, href = param.href;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PressableBox/* PressableBox */.K, {
        href: href,
        display: "inline-flex",
        flexDirection: "row",
        alignItems: "center",
        py: "$4x",
        px: "$8x",
        height: 72,
        "aria-label": "View link",
        "aria-current": active,
        "aria-expanded": isOpen,
        analyticsName: "cosmos-mega-nav-v2-nav-link-".concat(name),
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background:transparent;border:none;cursor:pointer;color:", (0,cjs.getToken)("$contentPrimary", "color"), ";text-decoration:none;gap:8px;line-height:100%;font-weight:500;&:hover,&:focus{color:", (0,cjs.getToken)("$contentAccentBrand", "color"), ";outline:0;}&:active{color:", (0,cjs.getToken)("$contentAccentBrand", "color"), ";}"),
        children: [
            children,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                alignItems: "center",
                justifyContent: "center",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:0.6em;height:0.6em;transition:transform 0.2s ease;transform:", isOpen ? "rotate(180deg)" : "rotate(0deg)", ";"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EiChevronDownIcon, {})
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/SkipLink.tsx
var SkipLink = __webpack_require__(50955);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/header/Header.tsx















var redirectToLogin = function() {
    document.location.href = "".concat(globals/* COSMOS_URL */.EQ, "/login?redirectTo=").concat(encodeURIComponent(window.location.pathname));
};
var Header = function(param) {
    var slug = param.slug, menuPanelNavLinks = param.menuPanelNavLinks, mainNavLinks = param.mainNavLinks, ctaTitle = param.ctaTitle, ctaLink = param.ctaLink, megaNavDataProp = param.megaNavData, closeMenuRef = param.closeMenuRef;
    var pathname = (0,router.useRouter)().pathname;
    var largerThanSM = (0,cjs.useMedia)().largerThanSM;
    var trackEvent = (0,observability/* useObservability */.C3)().trackEvent;
    var ref = (0,auth_fe2_esm/* useAuth */.aC)(), human = ref.user, authentication = ref.authentication;
    var isLoggedIn = authentication.state === "authenticated";
    var initials = (0,getInitials/* getInitials */.Q)(human === null || human === void 0 ? void 0 : human.fullName, human === null || human === void 0 ? void 0 : human.firstName);
    var ref1 = (0,react.useState)(false), isVisible = ref1[0], setIsVisible = ref1[1];
    var prevVisible = (0,usePrevious/* default */.Z)(isVisible);
    var toggleMenuOpen = function() {
        return setIsVisible(!isVisible);
    };
    var trackMenuClick = (0,react.useCallback)(function() {
        // TODO: remove categoryOverride
        // observability is initialized with 'cosmos' as the category for all events
        trackEvent("cta-click", "menu", undefined, {
            categoryOverride: "homepage"
        });
    }, [
        trackEvent
    ]);
    var trackAccountClick = (0,react.useCallback)(function() {
        // TODO: remove categoryOverride
        // observability is initialized with 'cosmos' as the category for all events
        trackEvent("cta-click", "account-icon", undefined, {
            categoryOverride: "homepage"
        });
    }, [
        trackEvent
    ]);
    // Hang on to burger button ref for focus management
    var ctaRef = (0,react.useRef)(null);
    // When menu close animation is complete
    // and it was previously open.
    // This prevents a focus from the initial animation state
    // on page load.
    var exitComplete = function() {
        if (prevVisible === true) {
            var activeEl = document.activeElement;
            var isInputFocused = (0,_instanceof/* default */.Z)(activeEl, HTMLInputElement) || (0,_instanceof/* default */.Z)(activeEl, HTMLTextAreaElement);
            if (!isInputFocused) {
                var ref;
                (ref = ctaRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            }
        }
    };
    //Hide Sign button on the sign in page
    var showLogin = !(pathname.includes("/login") || pathname.includes("/account"));
    (0,react.useEffect)(function() {
        if (closeMenuRef) {
            closeMenuRef.current = function() {
                return setIsVisible(false);
            };
        }
    }, [
        closeMenuRef
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            !largerThanSM && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuPanel/* default */.Z, {
                slug: slug,
                menuPanelNavLinks: menuPanelNavLinks,
                mainNavLinks: mainNavLinks,
                ctaTitle: ctaTitle,
                ctaLink: ctaLink,
                isVisible: isVisible,
                setIsVisible: setIsVisible,
                exitComplete: exitComplete,
                megaNavData: megaNavDataProp
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                display: "block",
                backgroundColor: "$backgroundPrimary",
                height: 72,
                zIndex: 2000,
                px: "$10x",
                $largerThanSM: {
                    px: 0
                },
                "$platform-web": {
                    position: "sticky",
                    top: 0
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    height: 72,
                    mx: "auto",
                    maxWidth: 1440,
                    $largerThanSM: {
                        px: "$20x"
                    },
                    $largerThanMD: {
                        px: "$32x"
                    },
                    "$platform-web": {
                        display: "grid",
                        gridTemplateColumns: "auto 1fr auto"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkipLink/* SkipLink */.G, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoSection/* LogoSection */.h, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MegaNav, {
                            slug: slug,
                            mainNavLinks: mainNavLinks,
                            megaNavData: megaNavDataProp
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                            alignItems: "center",
                            gap: "$12x",
                            pl: "$8x",
                            "$platform-web": {
                                gridRow: "1 / 2",
                                gridColumn: "-1 / -2"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccountSection/* AccountSection */.d, {
                                isLoggedIn: isLoggedIn,
                                showLogin: showLogin,
                                initials: initials,
                                redirectToLogin: redirectToLogin,
                                trackAccountClick: trackAccountClick,
                                trackMenuClick: trackMenuClick,
                                onMobileMenuToggle: toggleMenuOpen,
                                isMobileMenuVisible: isVisible,
                                hamburgerRef: ctaRef
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var header_Header = (Header);


/***/ }),

/***/ 25530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ LogoSection; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22470);
/* harmony import */ var components_landing_pages_v2_shared_OpendoorLogo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8222);




var LogoSection = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
        gridColumn: "1 / 2",
        gridRow: "1 / 2",
        pr: "$4x",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        zIndex: 5,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .r, {
                color: "$contentPrimary",
                href: "/",
                analyticsName: "cosmos-logo-link",
                "aria-label": "Go to Home page",
                display: "flex",
                alignItems: "center",
                $smallerThanMD: {
                    display: "none"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(components_landing_pages_v2_shared_OpendoorLogo__WEBPACK_IMPORTED_MODULE_4__/* .OpendoorLogo */ .o, {
                    width: "96px"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .r, {
                color: "$contentPrimary",
                href: "/",
                analyticsName: "cosmos-logo-link",
                "aria-label": "Go to Home page",
                display: "flex",
                alignItems: "center",
                $largerThanSM: {
                    display: "none"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(components_landing_pages_v2_shared_OpendoorLogo__WEBPACK_IMPORTED_MODULE_4__/* .OpendoorLogoBadge */ .j, {})
            })
        ]
    });
};


/***/ }),

/***/ 50955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ SkipLink; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2267);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76614);



var SkipLink = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), focused = ref[0], setFocused = ref[1];
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .PressableBox */ .K, {
        analyticsName: "cosmos-landing-page-v2-skip-to-main-content",
        "aria-label": "Skip navigation menu and view main content",
        role: "button",
        onPress: function() {
            if (false) {}
            var mainElem = document.querySelector("main");
            mainElem === null || mainElem === void 0 ? void 0 : mainElem.focus();
        },
        onFocus: function() {
            return setFocused(true);
        },
        onBlur: function() {
            return setFocused(false);
        },
        backgroundColor: "$backgroundPrimary",
        justifyContent: "center",
        width: "100%",
        py: "$3",
        px: "$4",
        zIndex: 1,
        "$platform-web": {
            position: "fixed",
            top: 0,
            left: 0,
            transform: focused ? "translateY(0)" : "translateY(-100%)",
            transition: "transform 0.2s ease-in-out"
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
            tag: "span",
            color: "$contentAccentBrand",
            typography: "$labelMedium",
            children: "Skip to main content"
        })
    });
};


/***/ }),

/***/ 32654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ menu_MenuPanel; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 142 modules
var motion = __webpack_require__(94796);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/trapFocus.ts
var trapFocus = __webpack_require__(92690);
// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe2.esm.js
var auth_fe2_esm = __webpack_require__(50671);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Row.js
var Row = __webpack_require__(6967);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/PressableBox.js
var PressableBox = __webpack_require__(2267);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./src/components/api/index.ts + 3 modules
var api = __webpack_require__(61661);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./src/helpers/observability.ts
var observability = __webpack_require__(9574);
// EXTERNAL MODULE: ./src/helpers/useBuyerOffers.tsx
var useBuyerOffers = __webpack_require__(13839);
// EXTERNAL MODULE: ./src/helpers/useLeads.tsx
var useLeads = __webpack_require__(65609);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/motion/MotionVariants.ts
var MotionVariants = __webpack_require__(81931);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/menuAnimations.ts

var menuVariants = {
    hidden: {
        opacity: 0,
        transition: {
            ease: "linear",
            duration: 0.1,
            delay: 1
        },
        transitionEnd: {
            display: "none"
        }
    },
    visible: {
        opacity: 1,
        transition: {
            ease: "linear",
            duration: 0.1
        },
        display: "block"
    }
};
var backdropVariants = {
    hidden: {
        opacity: 0,
        transition: {
            ease: MotionVariants/* defaultEase */.vI,
            delay: 0.3,
            duration: 0.2
        }
    },
    visible: {
        opacity: 1,
        transition: {
            ease: MotionVariants/* defaultEase */.vI,
            duration: 0.2
        }
    }
};
var boxVariants = {
    hidden: {
        x: "100%",
        transition: {
            ease: MotionVariants/* defaultEase */.vI,
            duration: 0.5
        }
    },
    visible: {
        x: 0,
        transition: {
            ease: MotionVariants/* defaultEase */.vI,
            duration: 0.5
        }
    }
};
var navList = {
    hidden: {
        opacity: 0,
        x: 64,
        transition: {
            duration: 0.4,
            staggerChildren: 0.05
        }
    },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.4,
            staggerChildren: 0.05
        }
    }
};
var ctaVariant = {
    hidden: {
        opacity: 0,
        transition: {
            ease: "linear",
            duration: 0.3
        }
    },
    visible: {
        opacity: 1,
        transition: {
            ease: "linear",
            delay: 0.3,
            duration: 0.3
        }
    }
};

// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Col.js
var Col = __webpack_require__(37122);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/utils/getInitials.ts
var getInitials = __webpack_require__(566);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Link/Link.js
var Link = __webpack_require__(22470);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/components/MenuLinkItem.tsx




var MenuLinkItem = function(param) {
    var href = param.href, name = param.name, analyticsName = param.analyticsName, isActive = param.isActive, onPress = param.onPress, isLast = param.isLast;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        tag: motion/* motion.li */.E.li,
        borderBottomWidth: isLast ? 0 : 1,
        borderColor: "$borderPrimary",
        $largerThanSM: {
            display: "none"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
            "aria-current": isActive,
            href: href,
            "aria-label": "View link",
            analyticsName: analyticsName,
            onPress: onPress,
            display: "inline-flex",
            alignItems: "center",
            paddingTop: "$8x",
            paddingBottom: "$8x",
            paddingLeft: "$12x",
            paddingRight: "$8x",
            backgroundColor: isActive ? "$backgroundStateHoverPrimary" : undefined,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "span",
                typography: "$bodyMedium",
                children: name
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconChevronRight.mjs
var IconChevronRight = __webpack_require__(97322);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/mobile/MobileMegaNavButton.tsx







var MobileMegaNavButton = function(param) {
    var itemName = param.itemName, onClick = param.onClick, isLast = param.isLast;
    var buttonProps = {
        onPress: onClick
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        tag: motion/* motion.li */.E.li,
        borderBottomWidth: isLast ? 0 : 1,
        borderColor: "$borderPrimary",
        $largerThanSM: {
            display: "none"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            tag: "button"
        }, buttonProps), {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            paddingTop: "$8x",
            paddingBottom: "$8x",
            paddingLeft: "$12x",
            paddingRight: "$9x",
            width: "100%",
            cursor: "pointer",
            borderWidth: "$0",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "span",
                    typography: "$bodyMedium",
                    children: itemName
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "span",
                    typography: "$bodySmall",
                    color: "$contentPrimary",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconChevronRight/* default */.Z, {
                        size: 24
                    })
                })
            ]
        }))
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/mobile/MobileMenuSectionHeader.tsx



var MobileMenuSectionHeader = function(param) {
    var label = param.label;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        backgroundColor: "$backgroundSecondary",
        borderTopWidth: 1,
        borderBottomWidth: 1,
        borderColor: "$borderPrimary",
        paddingTop: "$8x",
        paddingBottom: "$8x",
        paddingLeft: "$12x",
        paddingRight: "$8x",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
            tag: "span",
            typography: "$labelSmall",
            color: "$contentTertiary",
            children: label
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/mobile/MobileMenuList.tsx










var mainMenuVariants = {
    hidden: {
        x: "-100%",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        transition: {
            duration: 0.3,
            ease: "easeInOut"
        }
    },
    visible: {
        x: 0,
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        transition: {
            duration: 0.3,
            ease: "easeInOut"
        }
    }
};
var MobileMenuList = function(param) {
    var megaNavData = param.megaNavData, menuPanelNavLinks = param.menuPanelNavLinks, mainNavLinks = param.mainNavLinks, slug = param.slug, onSubMenuOpen = param.onSubMenuOpen, isLoggedIn = param.isLoggedIn, leads = param.leads, hasActiveOffers = param.hasActiveOffers, hasResaleDashboard = param.hasResaleDashboard, footer = param.footer;
    var ref = (0,auth_fe2_esm/* useAuth */.aC)(), human = ref.user;
    var trackEvent = (0,observability/* useObservability */.C3)().trackEvent;
    var hasLeads = leads && leads.length > 0;
    var fullName = human === null || human === void 0 ? void 0 : human.fullName;
    var initials = (0,getInitials/* getInitials */.Q)(fullName, human === null || human === void 0 ? void 0 : human.firstName);
    var renderAvatar = function() {
        if (!fullName) return null;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            backgroundColor: "$backgroundSecondary",
            borderTopWidth: 1,
            borderColor: "$borderPrimary",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "$8x",
            paddingTop: "$8x",
            paddingBottom: "$8x",
            paddingLeft: "$12x",
            paddingRight: "$12x",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    width: 32,
                    height: 32,
                    borderRadius: 9999,
                    backgroundColor: "$backgroundInversePrimary",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "span",
                        typography: "$labelSmall",
                        fontWeight: "$medium",
                        color: "$contentInversePrimary",
                        children: initials.join("")
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "span",
                    typography: "$labelMedium",
                    children: fullName
                })
            ]
        });
    };
    var renderAccountItems = function() {
        if (!isLoggedIn) return null;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                hasLeads && leads.slice(0, 3).map(function(lead) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLinkItem, {
                        href: lead.url,
                        name: "".concat(lead.address.street || "").concat(lead.readable_offer_state ? " (".concat(lead.readable_offer_state, ")") : ""),
                        analyticsName: "",
                        isActive: false
                    }, lead.id);
                }),
                leads && leads.length > 3 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLinkItem, {
                    href: "/properties",
                    name: "More",
                    analyticsName: "",
                    isActive: slug === "/properties"
                }, "more-leads"),
                hasResaleDashboard && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLinkItem, {
                    href: "/closing-dashboard",
                    name: "Closing dash",
                    analyticsName: "",
                    isActive: slug === "/closing-dashboard"
                }, "closing-dash"),
                hasActiveOffers && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLinkItem, {
                    href: "/dashboard",
                    name: "Dashboard",
                    analyticsName: "",
                    isActive: slug === "/dashboard",
                    onPress: function() {
                        return trackEvent("cta-click", "dashboard-link", undefined, {
                            categoryOverride: "homepage"
                        });
                    }
                }, "dashboard"),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLinkItem, {
                    href: "/account",
                    name: "Account",
                    analyticsName: "",
                    isActive: slug === "/account",
                    isLast: true,
                    onPress: function() {
                        return trackEvent("cta-click", "account-link", undefined, {
                            categoryOverride: "homepage"
                        });
                    }
                }, "account")
            ]
        });
    };
    var hasPanelLinks = menuPanelNavLinks && menuPanelNavLinks.length > 0;
    var navItems = megaNavData ? megaNavData.map(function(item, idx) {
        var hasSections = item.sections && item.sections.length > 0;
        var isLastNav = idx === megaNavData.length - 1 && !hasPanelLinks;
        if (hasSections) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileMegaNavButton, {
                itemName: item.name,
                onClick: function() {
                    return onSubMenuOpen(item.name);
                },
                isLast: isLastNav
            }, "mega-".concat(idx));
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLinkItem, {
            href: item.href,
            name: item.name,
            analyticsName: "cosmos-mega-nav-mobile-".concat(item.name.toLowerCase()),
            isActive: slug === item.href,
            isLast: isLastNav
        }, "mega-".concat(idx));
    }) : mainNavLinks.map(function(nav, idx) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLinkItem, {
            href: nav.href,
            name: nav.name,
            analyticsName: "cosmos-landing-page-v2-nav-link-".concat(nav.name),
            isActive: slug === nav.href,
            isLast: idx === mainNavLinks.length - 1 && !hasPanelLinks
        }, "main-".concat(idx));
    });
    var content = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            renderAvatar(),
            isLoggedIn && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                borderTopWidth: 1,
                borderColor: "$borderPrimary",
                children: renderAccountItems()
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileMenuSectionHeader, {
                label: "Resources"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                borderBottomWidth: 1,
                borderColor: "$borderPrimary",
                children: [
                    navItems,
                    menuPanelNavLinks === null || menuPanelNavLinks === void 0 ? void 0 : menuPanelNavLinks.map(function(link, idx) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLinkItem, {
                            href: link.href,
                            name: link.name,
                            analyticsName: "cosmos-landing-page-v2-menu-link-".concat(link.name),
                            isActive: slug === link.href,
                            isLast: idx === menuPanelNavLinks.length - 1
                        }, "panel-".concat(idx));
                    })
                ]
            })
        ]
    });
    if (megaNavData) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(motion/* motion.div */.E.div, {
            initial: "hidden",
            animate: "visible",
            exit: "hidden",
            variants: mainMenuVariants,
            style: {
                overflowY: "auto",
                overflowX: "hidden",
                background: (0,cjs.getToken)("$backgroundPrimary", "color"),
                display: "flex",
                flexDirection: "column"
            },
            children: [
                content,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                    flexGrow: 1,
                    justifyContent: "flex-end",
                    children: footer
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            content,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                flexGrow: 1
            }),
            footer
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconChevronLeft.mjs
var IconChevronLeft = __webpack_require__(48135);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/mobile/MobileSubMenuBackButton.tsx






var MobileSubMenuBackButton = function(param) {
    var onClick = param.onClick;
    var buttonProps = {
        onPress: onClick
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, buttonProps), {
        tag: "button",
        "aria-label": "Back",
        alignItems: "left",
        cursor: "pointer",
        paddingTop: "$8x",
        paddingBottom: "$6x",
        paddingLeft: "$12x",
        paddingRight: "$8x",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
            tag: "span",
            typography: "$bodySmall",
            color: "$contentPrimary",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconChevronLeft/* default */.Z, {
                size: 24
            })
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/mobile/MobileSubMenuSection.tsx





var MobileSubMenuSection = function(param) {
    var section = param.section, parentName = param.parentName;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileMenuSectionHeader, {
                label: section.title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                display: "flex",
                flexDirection: "column",
                children: section.links.map(function(link, linkIdx) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        tag: motion/* motion.li */.E.li,
                        borderBottomWidth: linkIdx < section.links.length - 1 ? 1 : 0,
                        borderColor: "$borderPrimary",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                            href: link.href,
                            textDecorationLine: "none",
                            "aria-label": "Navigate to ".concat(link.name),
                            analyticsName: "cosmos-mega-nav-mobile-".concat(parentName.toLowerCase(), "-").concat(link.name.toLowerCase().replace(/\s+/g, "-")),
                            paddingTop: "$8x",
                            paddingBottom: "$8x",
                            paddingLeft: "$12x",
                            paddingRight: "$8x",
                            display: "flex",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodyMedium",
                                color: "$contentPrimary",
                                children: link.name
                            })
                        })
                    }, linkIdx);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/mobile/MobileMenuSubMenu.tsx






var subMenuVariants = {
    hidden: {
        x: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        transition: {
            duration: 0.3,
            ease: "easeInOut"
        }
    },
    visible: {
        x: 0,
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        transition: {
            duration: 0.3,
            ease: "easeInOut"
        }
    }
};
var MobileMenuSubMenu = function(param) {
    var megaNavData = param.megaNavData, openSubMenu = param.openSubMenu, navList = param.navList, onBack = param.onBack, footer = param.footer;
    var ref;
    var currentItem = megaNavData.find(function(item) {
        return item.name === openSubMenu;
    });
    if (!currentItem) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(motion/* motion.div */.E.div, {
        initial: "hidden",
        animate: "visible",
        exit: "hidden",
        variants: subMenuVariants,
        style: {
            overflowY: "auto",
            overflowX: "hidden",
            background: (0,cjs.getToken)("$backgroundPrimary", "color")
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                borderTopWidth: 1,
                borderColor: "$borderPrimary"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileSubMenuBackButton, {
                onClick: onBack
            }),
            (ref = currentItem.sections) === null || ref === void 0 ? void 0 : ref.map(function(section, sectionIdx) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileSubMenuSection, {
                    section: section,
                    parentName: openSubMenu,
                    navList: navList
                }, sectionIdx);
            }),
            footer
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/components/MenuCTA.tsx






var MenuCTA = function(param) {
    var ctaLink = param.ctaLink, ctaTitle = param.ctaTitle, animate = param.animate;
    if (!(ctaLink === null || ctaLink === void 0 ? void 0 : ctaLink.name) || !(ctaLink === null || ctaLink === void 0 ? void 0 : ctaLink.href)) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.div */.E.div, {
        variants: ctaVariant,
        animate: animate,
        style: {
            paddingTop: 16,
            paddingBottom: 16,
            paddingLeft: 24,
            paddingRight: 24,
            width: "100%"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link/* Link */.r, {
            href: ctaLink.href,
            "aria-label": ctaLink.name,
            analyticsName: "cosmos-landing-page-v2-menu-cta-link-".concat(ctaLink.name),
            backgroundColor: "$backgroundSecondary",
            borderRadius: "$8x",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            paddingTop: "$8x",
            paddingBottom: "$8x",
            paddingLeft: "$10x",
            paddingRight: "$10x",
            textDecorationLine: "none",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    children: [
                        ctaTitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "span",
                            display: "block",
                            typography: "$labelSmall",
                            color: "$contentPrimary",
                            children: ctaTitle
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "span",
                            display: "block",
                            typography: "$bodySmall",
                            color: "$contentSecondary",
                            children: ctaLink.name
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "span",
                    typography: "$bodySmall",
                    color: "$contentPrimary",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconChevronRight/* default */.Z, {
                        size: 24
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/menu/components/MenuContent.module.css
var MenuContent_module = __webpack_require__(79962);
var MenuContent_module_default = /*#__PURE__*/__webpack_require__.n(MenuContent_module);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/components/MenuContent.tsx














var MenuContent = function(param) {
    var isVisible = param.isVisible, containerRef = param.containerRef, onAnimationComplete = param.onAnimationComplete, slug = param.slug, menuPanelNavLinks = param.menuPanelNavLinks, mainNavLinks = param.mainNavLinks, ctaLink = param.ctaLink, ctaTitle = param.ctaTitle, megaNavData = param.megaNavData, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant;
    var ref = (0,auth_fe2_esm/* useAuth */.aC)(), authentication = ref.authentication, logout = ref.logout, human = ref.user;
    var trackEvent = (0,observability/* useObservability */.C3)().trackEvent;
    var isLoggedIn = authentication.state === "authenticated";
    var leads = (0,useLeads/* useLeads */.v)();
    var hasActiveOffers = (0,useBuyerOffers/* useHasActiveBuyerOffers */.w)(true).hasActiveOffers;
    var ref1 = (0,react.useState)(false), hasResaleDashboard = ref1[0], setHasResaleDashboard = ref1[1];
    (0,react.useEffect)(function() {
        if (!human) {
            return;
        }
        (0,api/* getSessionExtras */.DF)().then(function(extras) {
            setHasResaleDashboard(extras.has_resale_closing_dashboard);
        });
    }, [
        human === null || human === void 0 ? void 0 : human.humanToken,
        human === null || human === void 0 ? void 0 : human.customerUuid
    ]);
    var handleSignOut = function() {
        trackEvent("cta-click", "account-signout", undefined, {
            categoryOverride: "homepage"
        });
        logout();
    };
    var animate = isVisible ? "visible" : "hidden";
    var ref2 = (0,react.useState)(null), openSubMenu = ref2[0], setOpenSubMenu = ref2[1];
    var signOutContent = isLoggedIn ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
        justifyContent: "center",
        py: "$4",
        px: "$3",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
            onPress: handleSignOut,
            "aria-label": "Sign out",
            analyticsName: "cosmos-account-menu-sign-out",
            display: "inline-flex",
            alignItems: "center",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "span",
                typography: "$bodyMedium",
                color: "$contentTertiary",
                children: "Sign out"
            })
        })
    }) : null;
    var menuFooter = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        pt: "$4",
        children: [
            signOutContent,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuCTA, {
                ctaLink: ctaLink,
                ctaTitle: ctaTitle,
                animate: animate
            })
        ]
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.div */.E.div, {
        onAnimationComplete: onAnimationComplete,
        variants: boxVariants,
        initial: "hidden",
        animate: isVisible ? "visible" : "hidden",
        exit: "hidden",
        tabIndex: -1,
        ref: containerRef,
        className: (MenuContent_module_default()).menuContainer,
        "data-variant": variant,
        role: "dialog",
        "aria-labelledby": "dialog-main-menu",
        "aria-modal": "true",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.ul */.E.ul, {
            animate: animate,
            variants: navList,
            className: (MenuContent_module_default()).menuList,
            role: "list",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
                initial: false,
                children: megaNavData && openSubMenu ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileMenuSubMenu, {
                    megaNavData: megaNavData,
                    openSubMenu: openSubMenu,
                    navList: navList,
                    onBack: function() {
                        return setOpenSubMenu(null);
                    },
                    footer: menuFooter
                }, "submenu") : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileMenuList, {
                    megaNavData: megaNavData,
                    menuPanelNavLinks: menuPanelNavLinks,
                    mainNavLinks: mainNavLinks,
                    slug: slug,
                    onSubMenuOpen: function(itemName) {
                        return setOpenSubMenu(itemName);
                    },
                    isLoggedIn: isLoggedIn,
                    leads: leads,
                    hasActiveOffers: hasActiveOffers,
                    hasResaleDashboard: hasResaleDashboard,
                    footer: menuFooter
                }, "mainmenu")
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/menu/MenuPanel.tsx








var Menu = function(param) {
    var slug = param.slug, menuPanelNavLinks = param.menuPanelNavLinks, mainNavLinks = param.mainNavLinks, ctaLink = param.ctaLink, ctaTitle = param.ctaTitle, isVisible = param.isVisible, setIsVisible = param.setIsVisible, exitComplete = param.exitComplete, megaNavData = param.megaNavData, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant;
    var containerRef = (0,react.useRef)(null);
    var animate = isVisible ? "visible" : "hidden";
    var onComplete = function(definition) {
        if (definition === "visible") {
            var ref;
            (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        } else {
            exitComplete();
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.div */.E.div, {
        variants: menuVariants,
        animate: animate,
        onKeyDown: function(e) {
            return (0,trapFocus/* trapFocus */.S)(e, containerRef);
        },
        style: {
            position: "fixed",
            inset: variant === "glass" ? "72px 0 0 0" : "0",
            zIndex: 1000
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            "$platform-web": {
                display: "grid"
            },
            height: "100%",
            width: "100%",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuContent, {
                    isVisible: !!isVisible,
                    containerRef: containerRef,
                    onAnimationComplete: onComplete,
                    slug: slug,
                    menuPanelNavLinks: menuPanelNavLinks,
                    mainNavLinks: mainNavLinks,
                    ctaLink: ctaLink,
                    ctaTitle: ctaTitle,
                    megaNavData: megaNavData,
                    variant: variant
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.div */.E.div, {
                    variants: backdropVariants,
                    initial: "hidden",
                    animate: isVisible ? "visible" : "hidden",
                    exit: "hidden",
                    "aria-hidden": "true",
                    onClick: function() {
                        return setIsVisible(false);
                    },
                    style: {
                        position: "fixed",
                        inset: variant === "glass" ? "72px 0 0 0" : "0",
                        zIndex: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.2)",
                        cursor: "pointer"
                    }
                })
            ]
        })
    });
};
var MenuPanel = function(param) {
    var slug = param.slug, menuPanelNavLinks = param.menuPanelNavLinks, mainNavLinks = param.mainNavLinks, ctaLink = param.ctaLink, ctaTitle = param.ctaTitle, isVisible = param.isVisible, setIsVisible = param.setIsVisible, exitComplete = param.exitComplete, megaNavData = param.megaNavData, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant;
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    var ref1 = (0,react.useState)(Boolean(isVisible)), shouldRender = ref1[0], setShouldRender = ref1[1];
    var isVisibleRef = (0,react.useRef)(Boolean(isVisible));
    isVisibleRef.current = Boolean(isVisible);
    (0,react.useEffect)(function() {
        return setMounted(true);
    }, []);
    (0,react.useEffect)(function() {
        if (isVisible) {
            setShouldRender(true);
        }
    }, [
        isVisible
    ]);
    (0,react.useEffect)(function() {
        document.body.classList.toggle("has-sheet", isVisible);
        return function() {
            return document.body.classList.remove("has-sheet");
        };
    }, [
        isVisible
    ]);
    var escFunction = (0,react.useCallback)(function(event) {
        if (event.key === "Escape") {
            setIsVisible(false);
        }
    }, []);
    (0,react.useEffect)(function() {
        document.addEventListener("keydown", escFunction, false);
        return function() {
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [
        escFunction
    ]);
    var handleExitComplete = (0,react.useCallback)(function() {
        if (!isVisibleRef.current) {
            setShouldRender(false);
        }
        exitComplete();
    }, [
        exitComplete
    ]);
    return mounted && shouldRender ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Menu, {
        slug: slug,
        menuPanelNavLinks: menuPanelNavLinks,
        mainNavLinks: mainNavLinks,
        ctaLink: ctaLink,
        ctaTitle: ctaTitle,
        isVisible: isVisible,
        setIsVisible: setIsVisible,
        exitComplete: handleExitComplete,
        megaNavData: megaNavData,
        variant: variant
    }) : null;
};
/* harmony default export */ var menu_MenuPanel = (MenuPanel);


/***/ }),

/***/ 81931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Z": function() { return /* binding */ show; },
/* harmony export */   "vI": function() { return /* binding */ defaultEase; }
/* harmony export */ });
/* unused harmony export defaultEaseCss */
var defaultEase = [
    0.55,
    0,
    0.15,
    1
];
var defaultEaseCss = "cubic-bezier(0.55, 0, 0.15, 1)";
var show = {
    start: {
        opacity: 0,
        y: 24
    },
    end: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.5,
            type: "spring"
        }
    }
};


/***/ }),

/***/ 92690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ trapFocus; }
/* harmony export */ });
var trapFocus = function(e, containerRef) {
    var ref;
    if (e.key !== "Tab") return;
    var containerElements = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var firstElement = containerElements && containerElements[0];
    var lastElement = containerElements && containerElements[containerElements.length - 1];
    // tabbing forwards on the last element (Careers)
    if (!e.shiftKey && document.activeElement === lastElement) {
        firstElement.focus();
        return e.preventDefault();
    }
    // tabbing backwards on the first element (Close button)
    if (e.shiftKey && document.activeElement === firstElement) {
        lastElement.focus();
        e.preventDefault();
    }
};


/***/ }),

/***/ 566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getInitials; }
/* harmony export */ });
/**
 * Derives user initials from fullName and firstName.
 * Uses firstName to determine where the last name starts in fullName,
 * matching the backend ParseName behavior.
 */ function getInitials(fullName, firstName) {
    if (!fullName) return [];
    var firstInitial = firstName === null || firstName === void 0 ? void 0 : firstName[0];
    var lastName = firstName ? fullName.replace(firstName, "").trim() : "";
    var lastInitial = lastName === null || lastName === void 0 ? void 0 : lastName[0];
    return [
        firstInitial,
        lastInitial
    ].filter(Boolean);
}


/***/ }),

/***/ 60132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var usePrevious = function(value) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
};
/* harmony default export */ __webpack_exports__["Z"] = (usePrevious);


/***/ }),

/***/ 13839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ useHasActiveBuyerOffers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_auth_fe__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50671);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77668);
/* harmony import */ var _components_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61661);






// Transaction states that indicate an offer is no longer active
var INACTIVE_STATES = [
    "CANCELED",
    "BUYER_WALKED",
    "REJECTED",
    "CONTRACT_FELL_THROUGH",
    "BACKUP_EXPIRED",
    "CLOSED",
    "UNKNOWN", 
];
var useHasActiveBuyerOffers = function() {
    var enabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var authentication = (0,_opendoor_auth_fe__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .aC)().authentication;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), hasActiveOffers = ref[0], setHasActiveOffers = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), hasFetched = ref2[0], setHasFetched = ref2[1];
    var idleCallbackScheduled = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // Don't fetch again if we already have the result
        if (hasFetched) {
            return;
        }
        // wait for auth to finish loading before checking offers
        if (!(authentication.state === "authenticated" || authentication.state === "not_authenticated")) {
            return;
        }
        // If not authenticated, user has no active offers
        if (authentication.state === "not_authenticated") {
            setHasActiveOffers(false);
            setIsLoading(false);
            setHasFetched(true);
            return;
        }
        function checkActiveOffers() {
            return _checkActiveOffers.apply(this, arguments);
        }
        function _checkActiveOffers() {
            _checkActiveOffers = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                var ref, ref1, result, offers, hasActive, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,_components_api__WEBPACK_IMPORTED_MODULE_1__/* .getAthenaClient */ .k8)().BuyerOffersMinimal()
                            ];
                        case 1:
                            result = _state.sent();
                            offers = result === null || result === void 0 ? void 0 : (ref = result.customerAccount) === null || ref === void 0 ? void 0 : (ref1 = ref.buying) === null || ref1 === void 0 ? void 0 : ref1.offers;
                            if (!offers || offers.length === 0) {
                                setHasActiveOffers(false);
                                setIsLoading(false);
                                setHasFetched(true);
                                return [
                                    2
                                ];
                            }
                            hasActive = offers.some(function(o) {
                                return !INACTIVE_STATES.includes(o.transactionState);
                            });
                            setHasActiveOffers(hasActive);
                            setIsLoading(false);
                            setHasFetched(true);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb(e);
                            setHasActiveOffers(false);
                            setIsLoading(false);
                            setHasFetched(true);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return _checkActiveOffers.apply(this, arguments);
        }
        // If dropdown is open, fetch immediately
        if (enabled) {
            checkActiveOffers();
            return;
        }
        // Schedule idle callback only once
        if (!idleCallbackScheduled.current && "object" !== "undefined" && "requestIdleCallback" in window) {
            idleCallbackScheduled.current = true;
            var idleCallbackId = window.requestIdleCallback(function() {
                checkActiveOffers();
                idleCallbackId = null; // Clear reference after execution
            });
            return function() {
                // Only cancel if it hasn't executed yet
                if (idleCallbackId !== null) {
                    window.cancelIdleCallback(idleCallbackId);
                }
                idleCallbackScheduled.current = false;
            };
        }
        // If requestIdleCallback is not supported or already scheduled, don't auto-fetch
        // User will fetch on dropdown open instead
        return;
    }, [
        enabled,
        authentication.state,
        hasFetched
    ]);
    return {
        hasActiveOffers: hasActiveOffers,
        isLoading: isLoading
    };
};


/***/ }),

/***/ 65609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useLeads; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_auth_fe__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50671);
/* harmony import */ var _components_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61661);
/* harmony import */ var _components_globals__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35480);






var buildHubUrl = function(addressUuid) {
    return "".concat(_components_globals__WEBPACK_IMPORTED_MODULE_2__/* .CONSUMER_FE_URL */ .ed, "/dashboard/sell/").concat(addressUuid);
};
var getReadableOfferState = function(offerState) {
    if (offerState === "SENT" || offerState === "ACCEPTED") {
        return "Offered";
    } else if (offerState === "EXPIRED") {
        return "Expired";
    } else if (offerState === "CONTINGENCY_RELEASED" || offerState === "IN_CONTRACT") {
        return "In Contract";
    } else if (offerState === "CLOSED") {
        return "Closed";
    }
    return;
};
var fetchLeads = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(customerUuid) {
        var leadsToShow, ref, ref1, leadsResponse, ref2, ref3, leads;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    leadsToShow = [];
                    if (!customerUuid) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,_components_api__WEBPACK_IMPORTED_MODULE_1__/* .getAthenaClient */ .k8)().ListLeadsOnUniqueAddresses({
                            customerUuid: customerUuid
                        })
                    ];
                case 1:
                    leadsResponse = _state.sent();
                    if ((ref = leadsResponse.sellDirect) === null || ref === void 0 ? void 0 : (ref1 = ref.listLeadsOnUniqueAddresses) === null || ref1 === void 0 ? void 0 : ref1.leads) {
                        ;
                        leads = (ref2 = leadsResponse.sellDirect) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.listLeadsOnUniqueAddresses) === null || ref3 === void 0 ? void 0 : ref3.leads;
                        leadsToShow = leads.filter(function(lead) {
                            return lead.isQualified;
                        }).map(function(lead) {
                            var ref, ref1, ref2;
                            return {
                                id: lead.id,
                                url: buildHubUrl((ref = lead.address) === null || ref === void 0 ? void 0 : ref.uuid),
                                address: {
                                    street: (ref1 = lead.address) === null || ref1 === void 0 ? void 0 : ref1.street
                                },
                                readable_offer_state: getReadableOfferState((ref2 = lead.latestOffer) === null || ref2 === void 0 ? void 0 : ref2.state)
                            };
                        });
                    }
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        leadsToShow
                    ];
            }
        });
    });
    return function fetchLeads(customerUuid) {
        return _ref.apply(this, arguments);
    };
}();
var useLeads = function() {
    var ref = (0,_opendoor_auth_fe__WEBPACK_IMPORTED_MODULE_5__/* .useAuth */ .aC)(), user = ref.user, authentication = ref.authentication;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), leads = ref1[0], setLeads = ref1[1];
    var customerUuid = user === null || user === void 0 ? void 0 : user.customerUuid;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // wait for auth to finish loading before getting leads
        if (!(authentication.state === "authenticated" || authentication.state === "not_authenticated")) {
            return;
        }
        function start() {
            return _start.apply(this, arguments);
        }
        function _start() {
            _start = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                var leadsToShow;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchLeads(customerUuid)
                            ];
                        case 1:
                            leadsToShow = _state.sent();
                            if (!leadsToShow) {
                                return [
                                    2
                                ];
                            }
                            setLeads(leadsToShow);
                            return [
                                2
                            ];
                    }
                });
            });
            return _start.apply(this, arguments);
        }
        start();
    }, [
        authentication.state,
        customerUuid
    ]);
    return leads;
};


/***/ }),

/***/ 79962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"MenuContent_menuContainer__1WL1w","menuList":"MenuContent_menuList__cGI4l"};

/***/ })

}]);